module.exports = __webpack_public_path__ + "static/media/arrow-circle-full-contrast.3a01e72b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-circle-full-contrast.svg
// module id = 323
// module chunks = 0